import { Component, OnInit, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { OrdersService } from '../../core/services/orders/orders.service';
import { AlertService } from '../../core/services/alert/alert.service';
import { AuthStateService } from '../../core/services/auth-state/auth-state-service.service';
import Swal from 'sweetalert2';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FilterComponent } from './filter/filter.component';
import { AccountsService } from '../../core/services/accounts/accounts.service';
import { BrandService } from '../../core/services/brand/brand.service';

interface AccountData {
  reference: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any;
  status: boolean;
}
interface ApiResponse {
  data: AccountData[];
}
interface DeliveryOrder {
  reference: string;
  broker_reference: string;
  vendor_reference?: string;
  supplier_reference?: string;
  stage: string;
  vendor: {
    reference?: string;
    name: string;
  };
  supplier: {
    reference?: string;
    name: string;
  };
  broker: {
    reference?: string;
    name: string;
  };
  client: {
    fullname: string;
  };
  vehicle: string;
  vehicle_status: string;
  vehicle_model_year: number;
  vehicle_units: number;
  colour: string;
  delivery_expected_date: string;
  manufacture_expected_date: string | null;
  require_action: boolean;
  require_action_note: number;
  priority: number;
  delivery_status: string;
  delivery_postal_code: string;
  license_plate: string;
  delivery_city?: string;
  calendar_priority?: string;
}

interface WeekDay {
  date: Date;
  dayName: string;
  dayNumber: number;
  orders: DeliveryOrder[];
  isToday: boolean;
}

@Component({
  selector: 'app-deliverys',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatFormFieldModule,
    FilterComponent
  ],
  templateUrl: './deliverys.component.html',
  styleUrls: ['./deliverys.component.css']
})
export class DeliverysComponent implements OnInit {
  accountType: string | null = null;
  currentWeekStart: Date = new Date();
  weekDays: WeekDay[] = [];
  deliveryData: { [key: string]: DeliveryOrder[] } = {};
  isLoading: boolean = false;
  ladata: any = [];
  cargaladata: any = [];

  // Datos de ejemplo basados en la nueva estructura del backend
  mockData = {
    "2025-10-14": [
      {
        "reference": "afc3fb09-3504-4113-b1ef-eca631533dfe",
        "broker_reference": "78347900384438",
        "stage": "contract_accepted",
        "vendor": {
          "name": "Arval"
        },
        "supplier": {
          "name": "Grupo Quadis"
        },
        "broker": {
          "name": "idoneo.com"
        },
        "vehicle": "Peugeot 208 Allure Puretech (100CV)",
        "vehicle_status": "new",
        "vehicle_model_year": 2025,
        "vehicle_units": 1,
        "colour": "BLANCO",
        "client": {
          "fullname": "JOSÉ RAMÓN GIL ARANDA"
        },
        "delivery_expected_date": "2025-10-14",
        "manufacture_expected_date": null,
        "require_action": false,
        "require_action_note": 0,
        "priority": 4,
        "delivery_status": "production",
        "delivery_postal_code": "48002",
        "license_plate": "1234ABC"
      }
    ],
    "2025-10-15": [
      {
        "reference": "bfc3fb09-3504-4113-b1ef-eca631533dfe",
        "broker_reference": "78347900384439",
        "stage": "ready_delivery",
        "vendor": {
          "name": "Santander Consumer"
        },
        "supplier": {
          "name": "Motor 16"
        },
        "broker": {
          "name": "idoneo.com"
        },
        "vehicle": "BMW Serie 3 320d",
        "vehicle_status": "new",
        "vehicle_model_year": 2025,
        "vehicle_units": 1,
        "colour": "AZUL",
        "client": {
          "fullname": "MARÍA CARMEN LÓPEZ PÉREZ"
        },
        "delivery_expected_date": "2025-10-15",
        "manufacture_expected_date": null,
        "require_action": false,
        "require_action_note": 0,
        "priority": 3,
        "delivery_status": "ready",
        "delivery_postal_code": "28001",
        "license_plate": "5678DEF"
      },
      {
        "reference": "cfc3fb09-3504-4113-b1ef-eca631533dfe",
        "broker_reference": "78347900384440",
        "stage": "in_production",
        "vendor": {
          "name": "Banco Sabadell"
        },
        "supplier": {
          "name": "AutoEuropa"
        },
        "broker": {
          "name": "idoneo.com"
        },
        "vehicle": "Audi A4 Avant 2.0 TDI",
        "vehicle_status": "new",
        "vehicle_model_year": 2025,
        "vehicle_units": 1,
        "colour": "NEGRO",
        "client": {
          "fullname": "FERNANDO GONZÁLEZ MARTÍN"
        },
        "delivery_expected_date": "2025-10-15",
        "manufacture_expected_date": "2025-09-30",
        "require_action": true,
        "require_action_note": 2,
        "priority": 2,
        "delivery_status": "production",
        "delivery_postal_code": "08001",
        "license_plate": "9101GHI"
      }
    ],
  };

  constructor(
    private orderService: OrdersService,
    private alertService: AlertService,
    private authStateService: AuthStateService,
    private translate: TranslateService,
    private accountService: AccountsService,
    private brandService: BrandService
  ) {
    this.setCurrentWeek();
  }

  ngOnInit(): void {
    this.getAccountTypeFromLocalStorage();
    this.fetchAllData();
  }

  getAccountTypeFromLocalStorage(): void {
    this.accountType = this.authStateService.getAccountType();
  }
  setCurrentWeek(): void {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Lunes como primer día
    this.currentWeekStart = new Date(today);
    this.currentWeekStart.setDate(today.getDate() + diff);
    this.currentWeekStart.setHours(0, 0, 0, 0);
  }

  generateWeekDays(): void {
    this.weekDays = [];
    const dayNames = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (let i = 0; i < 7; i++) {
      const date = new Date(this.currentWeekStart);
      date.setDate(this.currentWeekStart.getDate() + i);

      const dateKey = this.formatDateToKey(date);
      const orders = this.deliveryData[dateKey] || [];

      this.weekDays.push({
        date: date,
        dayName: dayNames[i],
        dayNumber: date.getDate(),
        orders: orders,
        isToday: date.getTime() === today.getTime()
      });
    }
  }

  loadDeliveryData(): void {
    // Este método ahora se mantiene para compatibilidad, pero los datos reales vienen de fetchData
    // this.deliveryData = this.mockData;
  }

  private fetchAllData() {
    Promise.all([
      this.fetchData(),
      this.fetchData2(),
      this.fetchData3(),
      this.fetchData8(),
    ]).then(() => {

      setTimeout(() => {
        this.ladata = this.cargaladata;
        this.ladata.flag = true;
        this.alertService.close();
      }, 1500);
    });
  }

  fetchData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      this.alertService.loading('swal_messages.please_wait');

      // Calcular las fechas de inicio y fin de la semana actual
      const startDate = this.formatDateToKey(this.currentWeekStart);
      const endDate = new Date(this.currentWeekStart);
      endDate.setDate(this.currentWeekStart.getDate() + 6);
      const endDateStr = this.formatDateToKey(endDate);

      this.orderService
        .getCalendarData(
          startDate,
          endDateStr,
          {},
          'delivery_expected_date',
          'vendor_reference,supplier_reference,vendor_quote_reference,created_at',
          'asc,asc,asc,asc'
        )
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.deliveryData = response.data || {};
              this.generateWeekDays();
              this.alertService.close();
              this.isLoading = false;
              resolve();
            } else {
              this.handleError('Error al cargar los datos del calendario');
              reject(new Error('API response not successful'));
            }
          },
          error: (error) => {
            this.handleError(error.error || 'Error al cargar los datos del calendario');
            reject(error);
          },
        });
    });
  }

  fetchData2(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.accountService.getData().subscribe({
        next: (response: ApiResponse) => {
          const data: AccountData[] = response.data;
          this.cargaladata.vendorData = data.filter(
            (item) => item.type === 'vendor'
          );
          this.cargaladata.brokerData = data.filter(
            (item) => item.type === 'broker'
          );
          this.cargaladata.supplierData = data.filter(
            (item) => item.type === 'supplier'
          );
          this.cargaladata.workshopData = data.filter(
            (item) => item.type === 'workshop'
          );
          this.cargaladata.dealershipData = data.filter(
            (item) => item.type === 'dealership'
          );
          resolve();
        },
        error: (error) => {
          reject(error); // Rechaza la promesa en caso de error
        },
      });
    });
  }
  fetchData3(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.brandService.getData().subscribe({
        next: (data) => {
          this.cargaladata.brands = data.data;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  fetchData8(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.orderService.getDeliveryData().subscribe({
        next: (data) => {
          this.cargaladata.delivery_place = data.data.places;
          this.cargaladata.delivery_status = data.data.status;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  private handleError(error: any): void {
    console.error('Error fetching delivery data:', error);
    this.isLoading = false;
    this.alertService.error(error);
    // En caso de error, usar datos mock para no romper la interfaz
    this.deliveryData = this.mockData;
    this.generateWeekDays();
  }

  formatDateToKey(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  previousWeek(): void {
    this.currentWeekStart.setDate(this.currentWeekStart.getDate() - 7);
    this.fetchData();
  }

  nextWeek(): void {
    this.currentWeekStart.setDate(this.currentWeekStart.getDate() + 7);
    this.fetchData();
  }

  goToToday(): void {
    this.setCurrentWeek();
    this.fetchData();
  }

  getWeekDateRange(): string {
    const endDate = new Date(this.currentWeekStart);
    endDate.setDate(this.currentWeekStart.getDate() + 6);

    const startStr = this.currentWeekStart.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'short'
    });
    const endStr = endDate.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });

    return `${startStr} - ${endStr}`;
  }

  getOrderCardClass(calendar_priority: string | undefined): string {
    const statusClasses: { [key: string]: string } = {
      'delivered': 'order-card order-card-delivered',
      'optional': 'order-card order-card-optional',
      'low': 'order-card order-card-low',
      'medium': 'order-card order-card-medium',
      'high': 'order-card order-card-high',
      'critical': 'order-card order-card-critical'
    };
    return calendar_priority ? statusClasses[calendar_priority] || 'order-card order-card-optional' : 'order-card order-card-optional';
  }



  openOrderInNewTab(orderReference: string): void {
    const url = `/orders/${orderReference}`;
    window.open(url, '_blank');
  }

  private getTranslation(key: string): string {
    return this.translate.instant(key);
  }

  reProgramar(orderReference: string): void {
    Swal.fire({
      title: this.getTranslation('swal_messages.reschedule.title'),
      html: `
        <div class="mb-3">
          <label for="nueva-fecha" class="form-label">${this.getTranslation('swal_messages.reschedule.select_date')}:</label>
          <input type="date" id="nueva-fecha" class="form-control" min="${new Date().toISOString().split('T')[0]}">
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: this.getTranslation('swal_messages.reschedule.confirm_button'),
      cancelButtonText: this.getTranslation('buttons.cancel'),
      confirmButtonColor: '#7933ff',
      cancelButtonColor: '#6c757d',
      preConfirm: () => {
        const fechaInput = document.getElementById('nueva-fecha') as HTMLInputElement;


        if (!fechaInput.value) {
          Swal.showValidationMessage(this.getTranslation('swal_messages.reschedule.validation.date_required'));
          return false;
        }

        const nuevaFecha = new Date(fechaInput.value);
        const fechaActual = new Date();
        fechaActual.setHours(0, 0, 0, 0);

        if (nuevaFecha < fechaActual) {
          Swal.showValidationMessage(this.getTranslation('swal_messages.reschedule.validation.date_future'));
          return false;
        }

        return {
          fecha: fechaInput.value
        };
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        this.enviarReprogramacion(orderReference, result.value.fecha);
      }
    });
  }

  private enviarReprogramacion(orderReference: string, nuevaFecha: string): void {
    const formData = {
      delivery_expected_date: nuevaFecha,
      updated_by: this.authStateService.getUserReference()
    };

    // Mostrar loading
    Swal.fire({
      title: this.getTranslation('swal_messages.please_wait'),
      text: this.getTranslation('swal_messages.reschedule.processing'),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    // Llamada al servicio para reprogramar usando updateData
    this.orderService.updateData(orderReference, formData).subscribe({
      next: (response: any) => {
        Swal.fire({
          icon: 'success',
          title: this.getTranslation('swal_messages.success'),
          text: this.getTranslation('swal_messages.reschedule.success_message'),
          confirmButtonColor: '#7933ff'
        }).then(() => {
          // Refrescar los datos del calendario
          this.fetchData();
        });
      },
      error: (error: any) => {
        console.error('Error al reprogramar entrega:', error);
        Swal.fire({
          icon: 'error',
          title: this.getTranslation('swal_messages.error'),
          text: this.getTranslation('swal_messages.reschedule.error_message'),
          confirmButtonColor: '#7933ff'
        });
      }
    });
  }


  /******* EVENTO DEL FILTRO  *******/
  filterChanged(searchTerm: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.alertService.loading('swal_messages.please_wait');
      const startDate = this.formatDateToKey(this.currentWeekStart);
      const endDate = new Date(this.currentWeekStart);
      endDate.setDate(this.currentWeekStart.getDate() + 6);
      const endDateStr = this.formatDateToKey(endDate);
      this.orderService
        .getCalendarData(
          startDate,
          endDateStr,
          searchTerm
        )
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.deliveryData = response.data || {};
              this.generateWeekDays();
              this.alertService.close();
              this.isLoading = false;
              resolve();
            } else {
              this.handleError('Error al cargar los datos del calendario');
              reject(new Error('API response not successful'));
            }
          },
          error: (error) => {
            this.handleError(error.error || 'Error al cargar los datos del calendario');
            reject(error);
          },
        });
    });
  }
}